import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';

import { InscricaoRouter } from './inscricao.router';
import { InscricaoService } from './shared/inscricao.service';

import { InscricaoComponent } from './inscricao.component';
import { CursoComponent } from './curso/curso.component';
import { DadosPessoaisComponent } from './dados-pessoais/dados-pessoais.component';
import { ParcelamentoComponent } from './parcelamento/parcelamento.component';
import { PagamentoComponent } from './pagamento/pagamento.component';
import { FinalizacaoComponent } from './finalizacao/finalizacao.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    InscricaoRouter,
  ],
  providers: [
    InscricaoService,
  ],
  declarations: [
    InscricaoComponent,
    CursoComponent,
    DadosPessoaisComponent,
    ParcelamentoComponent,
    PagamentoComponent,
    FinalizacaoComponent,
  ],
  exports: [
    InscricaoComponent,
    CursoComponent,
    DadosPessoaisComponent,
    ParcelamentoComponent,
    PagamentoComponent,
    FinalizacaoComponent,
  ],
})
export class InscricaoModule { }
